import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function confirmMission(id: number) {
  return restApiClient.url(constructApiUrl(API.missions.confirmMission.url, { id })).post()
}

export function confirmMissions(ids: number[]) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.missions.confirmMissions.url, null), { ids }))
    .post()
}
